import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { UserDTO } from '../models/UserDTO.model';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { UserRequestDTO } from '../shared/models/UserRequestDto';
import { PlanByUserDTO } from '../models/PlanByUserDTO.model';
import { SimpleRequestDTO } from '../shared/models/SimpleRequest';
import { UserGroupDTO } from '../models/UserGroupDTO.model';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {

  constructor(private httpService: HttpService) { }

  getMastersById(data: MasterdataRequestDTO) {
    return this.httpService.getMastersById(data).pipe(
      tap((data) => {
      })
    );
  }
  getListPartners() {
    return this.httpService.getListPartners().pipe(
      tap((data) => {
      })
    );
  }

  savePartner(partner: UserDTO) {
    return this.httpService.savePartner(partner).pipe(
      tap((data) => {
      })
    );
  }

  getListCustomersByPartnerId(data: SimpleRequestDTO) {
    return this.httpService.getListCustomersByPartnerId(data).pipe(
      tap((data) => {
      })
    );
  }

  getListCustomersAvailables(){
    return this.httpService.getListCustomersAvailables().pipe(
      tap((data) => {
      })
    );
  }

  addCustomersPartner(data: UserGroupDTO[]) {
    return this.httpService.addCustomersPartner(data).pipe(
      tap((data) => {
      })
    );
  }

  getAllPartnersAvailables() {
    return this.httpService.getAllPartnersAvailables().pipe(
      tap((data) => {
      })
    );
  }

  updateCustomersPartner(data: UserGroupDTO[]) {
    return this.httpService.updateCustomersPartner(data).pipe(
      tap((data) => {
      })
    );
  }

  getPartnerSummary(request: SimpleRequestDTO) {
    return this.httpService.getPartnerSummary(request).pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListPartners(){
    return this.httpService.exportToExcelListPartners().pipe(
      tap((data) => {
      })
    );
  }
  
  exportToExcelListPartnerCustomers(request: SimpleRequestDTO){
    return this.httpService.exportToExcelListPartnerCustomers(request).pipe(
      tap((data) => {
      })
    );
  }
}
